export default "__VITE_ASSET__k7VdHlS5__"